/*
 * <variant-cable-length>
 * Shows the cable length of the currently selected variant under the variant picker.
 * Values come from a per-variant metafield, rendered server-side into a JSON map
 * (variant id -> value). Updates live via the theme's global `variantChange` pub/sub event.
 */
if (!customElements.get('variant-cable-length')) {
  customElements.define(
    'variant-cable-length',
    class VariantCableLength extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector('[data-cable-row]');
        this.valueEl = this.querySelector('[data-cable-value]');
        try {
          this.map = JSON.parse(this.querySelector('[data-cable-map]').textContent);
        } catch (e) {
          this.map = {};
        }

        // This theme's <variant-selects> sets input[name="id"] and dispatches a
        // bubbling "change" on it for every variant change. Listen for that.
        this.onIdChange = (event) => {
          const target = event.target;
          if (!target || target.name !== 'id') return;
          this.update(target.value);
        };
        document.addEventListener('change', this.onIdChange);

        // Fallback: also honour the pub/sub event if a build ever publishes it.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event && event.data && event.data.variant) this.update(event.data.variant.id);
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onIdChange);
        if (this.unsubscribe) this.unsubscribe();
      }

      update(variantId) {
        const key = String(variantId);
        // Only react to variants that belong to this product (ignore other sections).
        if (!Object.prototype.hasOwnProperty.call(this.map, key)) return;
        const value = this.map[key];
        if (value == null || value === '') {
          this.row.hidden = true;
          this.valueEl.textContent = '';
        } else {
          this.valueEl.textContent = value;
          this.row.hidden = false;
        }
      }
    }
  );
}
